import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invite-offer" }
const _hoisted_2 = {
  key: 1,
  class: "link-in-use"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "You have already created a meeting with this offer link", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.linkInUse)
      ? (_openBlock(), _createBlock($setup["OptOffer"], {
          key: 0,
          offerLink: (_ctx.$route.params.offerLink as string),
          "is-preview": $setup.selfMeeting,
          onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.routeTo(''))),
          isLoading: $setup.loading
        }, null, 8 /* PROPS */, ["offerLink", "is-preview", "isLoading"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ]))
}